import React, { useState } from 'react';
import { Avatar } from '@material-ui/core';
import { TColumn } from './types';
import getInitials from 'src/utils/getInitials';
import { CapitalizeNames } from 'src/utils/capitalize';
import ModalImage from 'src/components/ModalImage';

interface IAvatarRow {
    column: TColumn;
    item: any;
}

export const AvatarRow = ({ column, item }: IAvatarRow) => {
    const [open, setOpen] = useState(false);
    const { field } = column;

    const imageUrl = item[field]
        ? `https://automotive-api.s3.us-east-2.amazonaws.com/${item[field]}`
        : null;

    const handleOpen = () => {
        if (imageUrl) {
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Avatar
                onClick={handleOpen}
                style={{
                    cursor: imageUrl ? 'pointer' : 'default',
                }}
                alt="User"
                src={imageUrl || undefined}
            >
                {item.name && getInitials(item.name)}
            </Avatar>
            {imageUrl && (
                <ModalImage
                    open={open}
                    setOpen={setOpen}
                    source={imageUrl}
                    title={CapitalizeNames(item.name)}
                />
            )}
        </>
    );
};
